var map = {
	"./": [
		82529,
		9
	],
	"./default/MaterialInfo": [
		97733,
		9,
		733
	],
	"./default/MaterialInfo.js": [
		97733,
		9,
		733
	],
	"./default/Recommendations": [
		3399,
		9,
		399
	],
	"./default/Recommendations.js": [
		3399,
		9,
		399
	],
	"./default/messages": [
		84813,
		3,
		813
	],
	"./default/messages.json": [
		84813,
		3,
		813
	],
	"./gold/MaterialInfo": [
		6067,
		9,
		67
	],
	"./gold/MaterialInfo.js": [
		6067,
		9,
		67
	],
	"./gold/Recommendations": [
		92270,
		9,
		270
	],
	"./gold/Recommendations.js": [
		92270,
		9,
		270
	],
	"./gold/messages": [
		21430,
		3,
		430
	],
	"./gold/messages.json": [
		21430,
		3,
		430
	],
	"./index": [
		82529,
		9
	],
	"./index.js": [
		82529,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 99419;
module.exports = webpackAsyncContext;